// src/pages/Convocations/ui/ConvocationStatusBadge.jsx

import React from "react";

import { RESPONSE_STATUS_META } from "../data/convocation.data";

import {
  cx,
  normalizeResponseStatus,
} from "../utils/convocation.utils";

export default function ConvocationStatusBadge({
  status,
  compact = false,
}) {
  const normalizedStatus =
    normalizeResponseStatus(status);

  const meta =
    RESPONSE_STATUS_META[
      normalizedStatus
    ];

  const Icon = meta.Icon;

  return (
    <span
      className={cx(
        "inline-flex items-center rounded-full border font-bold",
        compact
          ? "gap-1.5 px-2.5 py-1 text-[11px]"
          : "gap-2 px-3 py-1.5 text-xs",
        meta.className,
      )}
    >
      <Icon aria-hidden="true" />

      {meta.label}
    </span>
  );
}